import classNames from 'classnames';
import CardGeneric, { CardGenericProps } from '../Card/CardGeneric';
import CarouselGeneric from '../Carousel/CarouselGeneric';

export interface CardsBeforeAndAfterProps {
    items: CardBeforeAndAfter[];
    grid?: boolean;
}

export type CardBeforeAndAfter = CardGenericProps & {
    list: CardListItemProps[];
    person: PersonProps;
};

export type CardListItemProps = {
    label?: string;
    value?: string;
};

export type PersonProps = {
    fullName?: string;
    firstName?: string;
    lastName: string;
    degree?: string;
    specialty?: string;
    subtitle?: string;
    state?: string;
    city?: string;
    age?: number;
};

const CardsBeforeAndAfter = (props: CardsBeforeAndAfterProps) => {
    return (
        <CarouselGeneric>
            {props.items &&
                props.items.map((item: CardBeforeAndAfter, index: number) => {
                    return (
                        <div
                            className={classNames(
                                'w-[90%] shrink-0 snap-start sm:w-[55%] md:w-[380px]',
                                props.grid && 'lg:shrink xl:w-1/4',
                            )}
                            key={index}
                        >
                            <CardGeneric image={item.image}>
                                <div className="flex flex-row items-center justify-between bg-grey-100 px-4 py-2">
                                    <span className="font-demi text-regular">
                                        {item.person?.firstName}
                                        {item.person?.age &&
                                            `, ${item.person.age}`}
                                    </span>
                                    <span className="text-grey-400">
                                        {item.person?.state}
                                    </span>
                                </div>
                                {item.list &&
                                    item.list.map(
                                        (
                                            listItem: CardListItemProps,
                                            index: number,
                                        ) => {
                                            return (
                                                <div
                                                    className="px-4"
                                                    key={index}
                                                >
                                                    <div
                                                        className={classNames(
                                                            index ===
                                                                item.list
                                                                    .length -
                                                                    1
                                                                ? 'border-b-0'
                                                                : 'border-b border-grey-200',
                                                            'flex flex-row items-center justify-between py-2 text-sm tracking-tight',
                                                        )}
                                                    >
                                                        <span className="text-left text-grey-400">
                                                            {listItem.label}
                                                        </span>
                                                        <span className="text-right font-demi text-grey-400">
                                                            {listItem.value}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        },
                                    )}
                            </CardGeneric>
                        </div>
                    );
                })}
        </CarouselGeneric>
    );
};

const cardData = {
    person: {
        fullName: 'Angela',
        firstName: 'Angela',
        lastName: '',
        age: 37,
        state: 'WA',
    },
    list: [
        {
            label: 'Program type',
            value: 'Weight loss medication',
        },
        {
            label: 'Weight Lost',
            value: '10kg',
        },
        {
            label: 'Results shown',
            value: '5 weeks',
        },
    ],
    image: {
        src: '/images/hair/hair-before-after-brayden-loy-after.png',
        width: 272,
        height: 342,
        alt: 'Angela',
        split: [
            {
                src: '/images/hair/hair-before-after-brayden-loy-before.png',
                width: 272,
                height: 342,
                alt: 'Angela before',
            },
            {
                src: '/images/hair/hair-before-after-brayden-loy-after.png',
                width: 272,
                height: 342,
                alt: 'Angela after',
            },
        ],
    },
};

CardsBeforeAndAfter.defaultProps = {
    items: [
        { ...cardData },
        { ...cardData },
        { ...cardData },
        { ...cardData },
        { ...cardData },
    ],
};

export default CardsBeforeAndAfter;
